
export function News() {
  const newsItems = [
    {
      date: 'March 20, 2025',
      title: 'DJT Secures Major Investment for Urban Air Mobility Expansion',
      image: 'https://readdy.ai/api/search-image?query=modern%20electric%20vertical%20takeoff%20landing%20aircraft%20eVTOL%20drone%20aircraft%20on%20landing%20pad%20in%20futuristic%20city%20skyline%20with%20glass%20buildings%20clean%20white%20background%20professional%20corporate%20photography&width=800&height=500&seq=news1&orientation=landscape'
    },
    {
      date: 'February 18, 2025',
      title: 'Partnership Announced for eVTOL Operations in Major Metropolitan Areas',
      image: 'https://readdy.ai/api/search-image?query=business%20executives%20shaking%20hands%20in%20front%20of%20electric%20air%20aircraft%20modern%20office%20building%20background%20professional%20corporate%20photography%20clean%20composition&width=800&height=500&seq=news2&orientation=landscape'
    },
    {
      date: 'January 15, 2025',
      title: 'DJT Conducts Successful Test Flight Over Downtown District',
      image: 'https://readdy.ai/api/search-image?query=electric%20drone%20aircraft%20flying%20over%20modern%20city%20downtown%20area%20with%20skyscrapers%20blue%20sky%20professional%20aerial%20photography%20clean%20background&width=800&height=500&seq=news3&orientation=landscape'
    }
  ];

  return (
    <section id="news" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="text-sm font-semibold text-gray-500 mb-2 tracking-wider">
              Newsroom
            </p>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900">
              Keep up with the latest DJT news
            </h2>
          </div>
          <a href="#newsroom" className="hidden md:flex items-center text-gray-900 hover:text-teal-500 transition-colors group cursor-pointer">
            <span className="mr-2">Newsroom</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {newsItems.map((item, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="aspect-[16/10] overflow-hidden rounded-lg mb-4">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <p className="text-sm text-gray-500 mb-2">{item.date}</p>
              <h3 className="text-lg font-semibold text-gray-900 group-hover:text-teal-500 transition-colors">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
